"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.array.find");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
var _voucher = require("@/api/voucher");
var _enum = require("@/utils/enum");
var store = _interopRequireWildcard(require("@/api/store"));
var area = _interopRequireWildcard(require("@/api/area"));
var _ListOrder = _interopRequireDefault(require("./ListOrder"));
var _moment = _interopRequireDefault(require("moment"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Tinymce: _Tinymce.default,
    ListOrder: _ListOrder.default
  },
  data: function data() {
    var _this = this;
    var validDateEnd = function validDateEnd(rule, value, callback) {
      if (!value) {
        return callback(new Error("Vui lòng chọn ngày kết thúc"));
      }
      if (_this.formData.start > value) {
        return callback(new Error("Ngày kết thúc không nhỏ hơn"));
      }
      return callback();
    };
    return {
      dialogWidth: "500px",
      tempData: {},
      formData: {},
      dialogVisible: false,
      VoucherApplyType: _enum.VoucherApplyType,
      VoucherDiscountType: _enum.VoucherDiscountType,
      VoucherFormType: _enum.VoucherFormType,
      dialogStatus: "create",
      submitLoading: false,
      areas: [],
      dialogLoading: false,
      stores: [],
      tabName: "info",
      rules: {
        code: {
          required: true,
          trigger: "submit",
          message: "Vui lòng nhập code"
        },
        areaId: {
          required: true,
          trigger: "submit",
          message: "Vui lòng nhập khu vực"
        },
        start: {
          required: true,
          trigger: "submit",
          message: "Vui chọn ngày bắt đầu"
        },
        end: {
          required: true,
          trigger: "submit",
          validator: validDateEnd
        },
        discountValue: {
          required: true,
          trigger: "submit",
          message: "Vui lòng chọn nhập giá trị khuyến mãi"
        },
        quantity: {
          required: true,
          trigger: "submit",
          message: "Vui lòng chọn nhập số lượng"
        },
        usePerOne: {
          required: true,
          trigger: "submit",
          message: "Vui lòng nhập lượt sử dụng"
        }
      }
    };
  },
  created: function created() {
    this.fetchStore();
  },
  methods: {
    handleUpdate: function handleUpdate(row) {
      var _this2 = this;
      this.fetchRegion();
      this.dialogVisible = true;
      this.dialogStatus = "update";
      this.tabName = "info";
      this.$nextTick(function () {
        _this2.$refs["form"].clearValidate();
        _this2.formData = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, row), {}, {
          storeIds: row.stores.map(function (e) {
            return e.id;
          }),
          areaId: row.area ? row.area.id : undefined,
          start: _moment.default.unix(row.start).valueOf(),
          end: _moment.default.unix(row.end).valueOf()
        });
        var _loop = function _loop() {
          var e = row.stores[i];
          var find = _this2.stores.find(function (store) {
            return e.id == store.id;
          });
          if (!find) {
            _this2.stores.push(e);
          }
        };
        for (var i = 0; i < row.stores.length; i++) {
          _loop();
        }
      });
    },
    handleCreate: function handleCreate() {
      var _this3 = this;
      console.log("handlecreate");
      this.fetchRegion();
      this.dialogVisible = true;
      this.dialogStatus = "create";
      this.tabName = "info";
      this.$nextTick(function () {
        _this3.$refs["form"].clearValidate();
        _this3.$refs["form"].resetFields();
        _this3.formData = {
          isLimitQuantity: true,
          applyType: _enum.VoucherApplyType.All,
          storeIds: [],
          areaId: _this3.$store.state.user.info.area ? _this3.$store.state.user.info.area.id : undefined,
          discountType: _enum.VoucherDiscountType.Amount,
          form: _enum.VoucherFormType.Product
        };
      });
    },
    updateData: function updateData() {
      var _this4 = this;
      this.$refs["form"].validate(function (valid) {
        if (valid) {
          _this4.submitLoading = true;
          var start = (0, _moment.default)(_this4.formData.start).startOf("day").unix();
          var end = (0, _moment.default)(_this4.formData.end).endOf("day").unix();
          var data = {
            voucher: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this4.formData), {}, {
              start: start,
              end: end,
              quantity: !_this4.formData.isLimitQuantity ? 0 : _this4.formData.quantity
            }),
            storeIds: _this4.formData.storeIds,
            areaId: _this4.formData.areaId
          };
          _voucher.voucherApi.update(_this4.formData.id, data).then(function (res) {
            if (res.status) {
              _this4.$message({
                type: "success",
                message: "Cập nhật voucher thành công"
              });
              _this4.$emit("submit:success");
              _this4.dialogVisible = false;
            }
          }).finally(function () {
            _this4.submitLoading = false;
          });
        }
      });
    },
    createData: function createData() {
      var _this5 = this;
      this.$refs["form"].validate(function (valid) {
        if (valid) {
          _this5.submitLoading = true;
          var start = (0, _moment.default)(_this5.formData.start).startOf("day").unix();
          var end = (0, _moment.default)(_this5.formData.end).endOf("day").unix();
          var data = {
            voucher: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this5.formData), {}, {
              start: start,
              end: end,
              quantity: !_this5.formData.isLimitQuantity ? 0 : _this5.formData.quantity
            }),
            storeIds: _this5.formData.storeIds,
            areaId: _this5.formData.areaId
          };
          _voucher.voucherApi.create(data).then(function () {
            _this5.$message({
              type: "success",
              message: "Thêm voucher thành công"
            });
            _this5.$emit("submit:success");
            _this5.dialogVisible = false;
          }).finally(function () {
            _this5.submitLoading = false;
          });
        }
      });
    },
    fetchStore: function () {
      var _fetchStore = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var search,
          res,
          _args = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              search = _args.length > 0 && _args[0] !== undefined ? _args[0] : "";
              if (!(this.formData.areaId || this.$store.state.user.info.area)) {
                _context.next = 8;
                break;
              }
              _context.next = 4;
              return store.findAll({
                limit: 50,
                page: 1,
                search: search,
                areaId: this.formData.areaId || this.$store.state.user.info.area.id
              });
            case 4:
              res = _context.sent;
              this.stores = res.data.data;
              _context.next = 9;
              break;
            case 8:
              this.stores = [];
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchStore() {
        return _fetchStore.apply(this, arguments);
      }
      return fetchStore;
    }(),
    fetchRegion: function () {
      var _fetchRegion = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return area.findAll();
            case 2:
              res = _context2.sent;
              this.areas = res.data.areas;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchRegion() {
        return _fetchRegion.apply(this, arguments);
      }
      return fetchRegion;
    }()
  }
};